export type SocialAccount = {
  platform: 'Twitter' | 'LinkedIn' | 'Google Scholar' | 'IETF' | 'Google Patents' | 'Website';
  url: string;
}

export type AlumniOf = {
  name: string;
  url: string;
}

export type Author = {
  firstName: string;
  lastName: string;
  name: string;
  img: string;
  imgLarge: string;
  url?: string;
  title: string;
  bio: Array<string>;
  socials: Array<SocialAccount>;
  alumniOf: Array<AlumniOf>;
}

export function authorToLdJson(author: Author): string {
  return `{
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "${author.name}",
  "description": "${author.bio.join(' ')}",
  "email": "mailto:ruurtjan@nslookup.io",
  "jobTitle": "CEO",
  "image": {
    "@type": "ImageObject",
    "inLanguage": "en-US",
    "url": "https://www.nslookup.io/${author.imgLarge}",
    "contentUrl": "https://www.nslookup.io/${author.imgLarge}",
    "caption": "${author.name}"
  },
  "sameAs": [
    ${author.url ? `"https://www.nslookup.io${author.url}",` : ''}
    ${author.socials.map((social) => `"${social.url}"`).toString()}
  ],
  "alumniOf": [
    ${author.alumniOf.map((alumniOf) => `{"@type" : "CollegeOrUniversity", "name": "${alumniOf.name}", "sameAs": "${alumniOf.url}"}`).toString()}
  ],
  "mainEntityOfPage": {
      "@type": "ProfilePage",
      "url": "https://www.nslookup.io${author.url}",
      "name": "${author.name}",
      "description": "${author.bio.join(' ')}",
      "inLanguage": "en-US",
      "potentialAction": [
        {
          "@type": "ReadAction",
          "target": [
            "https://www.nslookup.io${author.url}"
          ]
        }
      ]
    }
}`;
}

export const ruurtjan: Author = {
  firstName: 'Ruurtjan',
  lastName: 'Pul',
  name: 'Ruurtjan Pul',
  img: 'img/ruurtjan.jpg',
  imgLarge: 'img/ruurtjan-lg.jpg',
  url: '/about/ruurtjan-pul/',
  title: 'Founder of NsLookup',
  bio: [
    'Passionate about sharing knowledge and making great DNS tools.',
    'I\'ve been working in IT for 15 years, and I recently quit my job to work full-time on NsLookup.',
  ],
  socials: [
    {
      platform: 'Website',
      url: 'https://www.ruurtjan.com/',
    },
    {
      platform: 'Twitter',
      url: 'https://twitter.com/Ruurtjan',
    },
    {
      platform: 'LinkedIn',
      url: 'https://www.linkedin.com/in/ruurtjan/',
    },
    {
      platform: 'Google Scholar',
      url: 'https://scholar.google.com/citations?user=kU3o4CwAAAAJ',
    },
  ],
  alumniOf: [
    {
      name: 'Hanze University of Applied Sciences',
      url: 'https://en.wikipedia.org/wiki/Hanze_University_of_Applied_Sciences',
    },
    {
      name: 'University of Groningen',
      url: 'https://en.wikipedia.org/wiki/University_of_Groningen',
    },
  ],
};

export const jeff: Author = {
  firstName: 'Jeff',
  lastName: 'Westhead',
  name: 'Jeff Westhead',
  img: 'img/jeff.jpg',
  imgLarge: 'img/jeff-lg.jpg',
  url: '/about/jeff-westhead/',
  title: 'Technical writer',
  bio: [
    'At Microsoft, Jeff worked on DNS in both Windows and Azure.',
    'With his 28 years of experience in network engineering, he is an expert on DNS and DNSSEC.',
  ],
  socials: [
    {
      platform: 'IETF',
      url: 'https://datatracker.ietf.org/person/Jeff%20Westhead',
    },
    {
      platform: 'LinkedIn',
      url: 'https://www.linkedin.com/in/jeff-westhead-7136149a',
    },
    {
      platform: 'Google Scholar',
      url: 'https://scholar.google.com/citations?user=au2lr8sAAAAJ',
    },
    {
      platform: 'Google Patents',
      url: 'https://patents.google.com/?inventor=Jeffrey+Westhead',
    },
  ],
  alumniOf: [
    {
      name: 'University of Waterloo',
      url: 'https://en.wikipedia.org/wiki/University_of_Waterloo',
    },
  ],
};

export const steven: Author = {
  firstName: 'Steven',
  lastName: 'Reitsma',
  name: 'Steven Reitsma',
  img: 'img/steven.jpg',
  imgLarge: 'img/steven.jpg',
  title: 'MLOps engineer',
  bio: [
    'With over six years experience as an MLOps engineer, Steven has debugged many DNS issues in Kubernetes.',
  ],
  socials: [
    {
      platform: 'Website',
      url: 'https://reitsma.io/',
    },
    {
      platform: 'LinkedIn',
      url: 'https://www.linkedin.com/in/steven-reitsma/',
    },
  ],
  alumniOf: [
    {
      name: 'Radboud University Nijmegen',
      url: 'https://en.wikipedia.org/wiki/Radboud_University_Nijmegen',
    },
  ],
};

export const holly: Author = {
  firstName: 'Holly',
  lastName: 'Smith',
  name: 'Holly Smith',
  img: 'img/holly.jpg',
  imgLarge: 'img/holly.jpg',
  url: undefined,
  title: 'Guest writer',
  bio: [
    'Holly Smith is an online marketer and writer. She writes about SaaS tech, branding, and marketing.',
    'Her content helps small business owners and entrepreneurs make informed decisions and grow their businesses online.',
  ],
  socials: [],
  alumniOf: [],
};
